"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTheme = {
  name: 'Default',
  header: {
    color: '#fff',
    background: '#0053ad',
    backgroundTop: 'transparent',
    boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.5)',
    position: 'fixed'
  },
  footer: {
    color: '#fff',
    background: '#002246',
    boxShadow: '',
    position: ''
  },
  colors: {
    background: {
      color: '#fff',
      onColor: '#000'
    },
    default: {
      color: '#808080',
      onColor: '#fff'
    },
    primary: {
      color: '#007bff',
      onColor: '#fff'
    },
    secondary: {
      color: '#6c757d',
      onColor: '#fff'
    },
    success: {
      color: '#28a745',
      onColor: '#fff'
    },
    danger: {
      color: '#dc3545',
      onColor: '#fff'
    },
    warning: {
      color: '#ffc107',
      onColor: '#fff'
    },
    info: {
      color: '#17a2b8',
      onColor: '#fff'
    },
    surface: {
      color: '#fff',
      onColor: '#000'
    },
    highlight: {
      color: '#f8f9fa',
      onColor: '#000'
    }
  },
  texts: {
    normal: {
      font: "'Open Sans', sans-serif",
      color: '#000'
    },
    heading1: {
      font: 'Lato, sans-serif',
      color: '#000'
    },
    heading2: {
      font: 'Lato, sans-serif',
      color: '#000'
    },
    heading3: {
      font: 'Lato, sans-serif',
      color: '#000'
    },
    heading4: {
      font: 'Lato, sans-serif',
      color: '#000'
    },
    heading5: {
      font: 'Lato, sans-serif',
      color: '#000'
    },
    heading6: {
      font: 'Lato, sans-serif',
      color: '#000'
    }
  },
  section: {
    minHeight: 'auto',
    paddingTop: 0,
    paddingHorizontal: 0,
    paddingBottom: 0
  },
  container: {
    minHeight: 'auto',
    xsWidth: 0,
    smWidth: 540,
    mdWidth: 720,
    lgWidth: 960,
    xlWidth: 1140,
    xxlWidth: 1500,
    paddingTop: 0,
    paddingHorizontal: 15,
    paddingBottom: 0
  },
  card: {
    color: '#000',
    background: '#fff',
    paddingTop: 15,
    paddingHorizontal: 15,
    paddingBottom: 30,
    paddingInner: 15,
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12)',
    marginBottom: 15,
    borderRadius: 4
  },
  input: {
    font: 'sans-serif',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderColor: '#ccc',
    color: '#000',
    background: '#fff',
    borderRadius: 4
  },
  button: {
    font: 'sans-serif',
    fontSize: '16px',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 4
  },
  default: {
    padding: 15,
    borderRadius: 4
  },
  thresholds: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600
  }
};
exports.emptyTheme = {
  name: 'Empty',
  header: {
    color: '',
    background: '',
    backgroundTop: '',
    boxShadow: '',
    position: ''
  },
  footer: {
    color: '',
    background: '',
    boxShadow: '',
    position: ''
  },
  colors: {
    background: {
      color: '',
      onColor: ''
    },
    default: {
      color: '',
      onColor: ''
    },
    primary: {
      color: '',
      onColor: ''
    },
    secondary: {
      color: '',
      onColor: ''
    },
    success: {
      color: '',
      onColor: ''
    },
    danger: {
      color: '',
      onColor: ''
    },
    warning: {
      color: '',
      onColor: ''
    },
    info: {
      color: '',
      onColor: ''
    },
    surface: {
      color: '',
      onColor: ''
    },
    highlight: {
      color: '',
      onColor: ''
    }
  },
  texts: {
    normal: {
      font: '',
      color: ''
    },
    heading1: {
      font: '',
      color: ''
    },
    heading2: {
      font: '',
      color: ''
    },
    heading3: {
      font: '',
      color: ''
    },
    heading4: {
      font: '',
      color: ''
    },
    heading5: {
      font: '',
      color: ''
    },
    heading6: {
      font: '',
      color: ''
    }
  },
  section: {
    minHeight: '',
    paddingTop: 0,
    paddingHorizontal: 0,
    paddingBottom: 0
  },
  container: {
    minHeight: '',
    xsWidth: 0,
    smWidth: 0,
    mdWidth: 0,
    lgWidth: 0,
    xlWidth: 0,
    xxlWidth: 0,
    paddingTop: 0,
    paddingHorizontal: 0,
    paddingBottom: 0
  },
  default: {
    padding: 0,
    borderRadius: 0
  },
  card: {
    color: '',
    background: '',
    paddingTop: 0,
    paddingHorizontal: 0,
    paddingBottom: 0,
    paddingInner: 0,
    boxShadow: '',
    marginBottom: 0,
    borderRadius: 0
  },
  input: {
    font: '',
    paddingVertical: 0,
    paddingHorizontal: 0,
    borderColor: '',
    borderRadius: 0,
    color: '',
    background: ''
  },
  button: {
    font: '',
    fontSize: '',
    paddingVertical: 0,
    paddingHorizontal: 0,
    borderRadius: 0
  },
  thresholds: {
    sm: 0,
    md: 0,
    lg: 0,
    xl: 0,
    xxl: 0
  }
};